<template>
  <DefaultPageContainer>
    <DefaultHero/>
    <DefaultCarousel/>
    <DefaultTabsContainer/>
  </DefaultPageContainer>
</template>

<script setup lang="ts">
// i18n routing
definePageMeta({
  name: 'homepage',
})

// Set SEO meta
useSeoWrapper().setSeoMeta()
</script>

